/**
 * Settings module translations - Empty States section
 */

const emptyStates = {
  noDataAvailable: "No data available",
  refresh: "Refresh",
  noCountriesAdded: "No countries added",
};

export default emptyStates;
